import React, {Component} from 'react'
import {Col, DatePicker, Form, Row, Select} from 'antd'
import {dateVal} from '../../../../../modules/Utils'
import {get} from 'lodash'
import {compose} from 'recompose'
import withSelectFetch from '../../../../../elements/Select/withSelectFetch'
import withSpinning from '../../../../../elements/HOC/withSpinning'
import withSubDropdown from '../../../../../elements/HOC/withSubDropdown'
import withSort from '../../../../../elements/HOC/withSort'
import CustomSelect from '../../../../../elements/Select/CustomSelect'

const FormItem = Form.Item
const {Option} = Select
const RangePicker = DatePicker.RangePicker

const CreditTerms = compose(
  withSelectFetch({dropdown: 'supplier', name: 'terms'}),
  withSpinning,
  withSubDropdown({name: 'credit'}),
  withSort,
)(CustomSelect)

class KeyTerms extends Component {
  render() {
    const formItemLayout = {
      labelCol: {
        xs: {span: 24},
        sm: {span: 7},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
    }
    const {getFieldDecorator} = this.props.form
    const {contract} = this.props

    return (
      <div>
        <Form layout="horizontal">
          <Row>
            <Col span={12}>
              <FormItem label="Contract Date" {...formItemLayout}>
                {getFieldDecorator('date.start', {
                  initialValue: dateVal(contract, 'date.start'),
                  rules: [
                    {
                      required: true,
                      message: "Contract Date can't be empty ",
                    },
                  ],
                })(
                  <DatePicker
                    style={{width: '100%'}}
                    placeholder="Contract Date"
                  />,
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Contract End Date" {...formItemLayout}>
                {getFieldDecorator('date.expiry', {
                  initialValue: dateVal(contract, 'date.expiry'),
                })(
                  <DatePicker style={{width: '100%'}} placeholder="End Date" />,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <FormItem label="Effective Date" {...formItemLayout}>
                {getFieldDecorator('date.effective', {
                  initialValue: dateVal(contract, 'date.effective'),
                  rules: [
                    {
                      required: true,
                      message: "Start Date can't be empty ",
                    },
                  ],
                })(
                  <DatePicker
                    style={{width: '100%'}}
                    placeholder="Start Date"
                  />,
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Credit Terms" {...formItemLayout}>
                {getFieldDecorator('terms.credit', {
                  initialValue: get(contract, 'terms.credit'),
                  rules: [
                    {
                      required: true,
                      message: "Credit Terms can't be empty ",
                    },
                  ],
                })(<CreditTerms placeholder="Credit Terms" />)}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
    )
  }
}

export default Form.create()(KeyTerms)
